<template>
  <section>
    <div class="row" v-if="downloadable_efile === null && printable_efile === null">
      <div class="col">
        <span>{{ $t('picture.efile-list.message.no-efile') }}</span>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col">
        <div class="row" v-if="downloadable_efile != null">
          <div class="col">
            ({{ $t('picture.efile-list.label.downloadable') }}) <a :href="downloadable_efile.url" target="_blank" download>{{ downloadable_efile.name }}</a> ({{ downloadable_efile.formatted_size }})
          </div>
        </div>
        <div class="row mt-3" v-if="printable_efile != null">
          <div class="col">
            ({{ $t('picture.efile-list.label.printable') }}) <a :href="printable_efile.url" target="_blank" download>{{ printable_efile.name }}</a> ({{ printable_efile.formatted_size }})
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: 'picture-efile-list',
  props: {
    downloadable_efile: {
      type: Object,
      default: null
    },
    printable_efile: {
      type: Object,
      default: null
    }
  },
  methods: {
    // 
  },
  created() {
    // 
  },
  components: {
    // 
  }  
}
</script>